import React, { Component } from "react";
import { connect } from "react-redux";
import { getReport, getStandaloneReport } from "./actions";
import MapContainer from "./MapContainer";
import { StyledHeader } from "../../styles";
import { cellStyle as cstyle } from "../gridHelper";
import { Card, CardContent, Button, Typography } from "@material-ui/core";
import { selectCurrentReport } from "./selectors";
import ReactToPrint from "react-to-print";
import { gridStyle, cellStyle } from "../gridHelper";
import "../imgDiv.css";
import { noImg } from "vrcore-dashboard/dist/utilities";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import PrintIcon from "@material-ui/icons/Print";

class CovidReturnToWork extends Component {
    constructor(props) {
        super(props);
        const path = props.location.pathname.split("/");
        if (path[2] === "reports") {
            props.getStandaloneReport(
                path[2].replace(/-/g, "_"),
                path[3],
                path[5].replace(/_/g, " ").replace(/\./g, ":"),
                path[4].replace(/-/g, "_")
            );
        } else {
            props.getReport(
                path[6],
                path[2].replace(/-/g, "_"),
                path[3],
                path[4].replace(/-/g, "_"),
                path[5].replace(/-/g, "_"),
                props.match.params.report_id
                    .replace(/_/g, " ")
                    .replace(/\./g, ":"),
                path[7].replace(/-/g, "_")
            );
        }
        this.state = {
            reportRetrieved: false,
            report: [],
            imageModal: false,
            selectedImg: false,
        };
    }
    componentDidUpdate(prevState) {
        if (prevState.report !== this.props.report) {
            this.setState({ report: this.props.report });
        }
    }

    renderPhotos(attachedPhotos) {
        let photoRow = 2;
        let photoCell = 1;
        return attachedPhotos.map((photo, i) => {
            let photoInfo = (
                <React.Fragment key={i}>
                    <div
                        style={cstyle(
                            photoRow,
                            photoCell,
                            photoRow,
                            photoCell,
                            true
                        )}
                    >
                        {photo.photo_name}
                    </div>
                    <div
                        style={cstyle(
                            photoRow,
                            photoCell + 1,
                            photoRow,
                            photoCell + 1,
                            true
                        )}
                    >
                        {photo.photo_timestamp}
                    </div>
                    <div
                        style={cstyle(
                            photoRow + 1,
                            photoCell,
                            photoRow + 1,
                            photoCell + 2
                        )}
                    >
                        <img
                            src={photo.photo_url}
                            alt="Site "
                            onClick={() => {
                                this.setState({
                                    selectedImg: photo.photo_url,
                                    imageModal: true,
                                });
                            }}
                            style={{
                                width: 300,
                                height: 300,
                                margin: "auto",
                                cursor: "pointer",
                            }}
                        />
                    </div>
                </React.Fragment>
            );
            photoCell += 2;
            if (photoCell === 9) {
                photoRow += 2;
                photoCell = 1;
            }
            return photoInfo;
        });
    }

    renderSigs(attachedSigs) {
        let sigRow = 2;
        let sigCell = 1;
        let ref = "";
        return attachedSigs.map((sig, i) => {
            if (sig.signature_url.includes("https:") === false) {
                ref = "data:image/png;base64," + sig.signature_url;
            }
            let sigInfo = (
                <React.Fragment key={i}>
                    <div
                        style={cellStyle(
                            sigRow,
                            sigCell,
                            sigRow,
                            sigCell,
                            true
                        )}
                    >
                        {sig.signature_name}
                    </div>
                    <div
                        style={cellStyle(
                            sigRow,
                            sigCell + 1,
                            sigRow,
                            sigCell + 1,
                            true
                        )}
                    >
                        {sig.signature_timestamp}
                    </div>
                    {sig.signature_url.includes("https:") ? (
                        <div
                            style={cellStyle(
                                sigRow + 1,
                                sigCell,
                                sigRow + 1,
                                sigCell + 2
                            )}
                        >
                            <img
                                src={sig.signature_url}
                                alt="Site "
                                onClick={() => {
                                    this.setState({
                                        selectedPhoto: sig.signature_url,
                                        imageModal: true,
                                    });
                                }}
                                style={{
                                    width: 300,
                                    height: 300,
                                    margin: "auto",
                                    cursor: "pointer",
                                }}
                            />
                        </div>
                    ) : (
                        <div
                            style={cellStyle(
                                sigRow + 1,
                                sigCell,
                                sigRow + 1,
                                sigCell + 2
                            )}
                        >
                            <img
                                src={ref}
                                alt="Site "
                                onClick={() => {
                                    this.setState({
                                        selectedPhoto: ref,
                                        imageModal: true,
                                    });
                                }}
                                style={{
                                    width: 300,
                                    height: 300,
                                    margin: "auto",
                                    cursor: "pointer",
                                }}
                            />
                        </div>
                    )}
                </React.Fragment>
            );
            sigCell += 2;
            if (sigCell === 9) {
                sigRow += 2;
                sigCell = 1;
            }
            return sigInfo;
        });
    }

    render() {
        const report = this.props.report === false ? [] : this.props.report;
        const cstyle = cellStyle;
        const gstyle = gridStyle;
        let color = this.props.color;
        return (
            <Card>
                <StyledHeader style={{ background: "#0188cc" }}>
                    <Typography variant="h5" style={{ color: "white" }}>
                        COVID-19: Return to Work Safely Protocol Report
                        <ReactToPrint
                            onBeforePrint={() => {
                                setTimeout(undefined, 2000);
                            }}
                            trigger={() => (
                                <PrintIcon
                                    style={{
                                        float: "right",
                                        fontSize: "36px",
                                        marginRight: "30px",
                                        cursor: "pointer",
                                    }}
                                />
                            )}
                            content={() => this.componentRef}
                        />
                    </Typography>
                </StyledHeader>
                <CardContent>
                    {report && (
                        <div ref={(el) => (this.componentRef = el)}>
                            {this.props.header && (
                                <this.props.header
                                    date={this.props.match.params.report_id}
                                    reportType={this.props.reportType}
                                />
                            )}
                            <div style={{ width: "100%" }}>
                                <div style={{ width: "48%", float: "left" }}>
                                    <div style={gstyle(7, 13, null, color)}>
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                13,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Information</b>
                                        </div>
                                        <div style={cstyle(2, 1, 2, 13)}>
                                            <b>Name:</b>&nbsp;{" "}
                                            {report.user_name
                                                ? report.user_name
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(3, 1, 3, 13, true)}>
                                            <b>Email:</b>&nbsp;{" "}
                                            {report.user_email
                                                ? report.user_email
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(4, 1, 4, 13)}>
                                            <b>Date:</b>&nbsp;{" "}
                                            {report.timestamp
                                                ? report.timestamp
                                                : "N/A"}
                                        </div>

                                        <div style={cstyle(5, 1, 5, 13)}>
                                            <b>Longitude:</b>&nbsp;{" "}
                                            {report.location_lon
                                                ? report.location_lon
                                                : "N/A"}
                                        </div>

                                        <div style={cstyle(6, 1, 6, 13, true)}>
                                            <b>Latitude:</b>&nbsp;{" "}
                                            {report.location_lat
                                                ? report.location_lat
                                                : "N/A"}
                                        </div>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        width: "50%",
                                        float: "left",
                                        marginLeft: "2%",
                                    }}
                                >
                                    <MapContainer
                                        lat={+report.location_lat}
                                        long={+report.location_lon}
                                        style={{ width: "80%" }}
                                    />
                                    <br />
                                    <br />
                                </div>
                            </div>
                            <div
                                style={{
                                    width: "100%",
                                    clear: "both",
                                    marginBottom: "10px",
                                    marginTop: "10px",
                                }}
                            >
                                <Typography
                                    style={{
                                        border: "4px solid #0188cc",
                                        borderRadius: "6px",
                                        padding: "5px",
                                    }}
                                >
                                    This Checklist has been developed to help
                                    inform workers about what they need to do to
                                    help prevent the spread of COVID-19 in their
                                    workplace. Employers and workers must work
                                    together to protect everyone at the
                                    workplace. Further Information can be found
                                    at{" "}
                                    <b>
                                        www.Gov.ie, www.hse.ie, www.hpsc.ie and
                                        www.hsa.ie{" "}
                                    </b>
                                </Typography>
                            </div>

                            <div style={{ width: "100%", clear: "both" }}>
                                <div style={gstyle(4, 4)}>
                                    <div
                                        style={cstyle(1, 1, 1, 4, false, true)}
                                    >
                                        <b>Protocols</b>
                                    </div>
                                    <div style={cstyle(2, 1, 2, 2)}>
                                        <b>
                                            1. &nbsp;Do you feel well and fit
                                            enough to return to work?
                                        </b>
                                    </div>
                                    <div style={cstyle(2, 2, 2, 3)}>
                                        <b>
                                            {report.q1_value === "Yes"
                                                ? "Yes"
                                                : report.q1_value === "No"
                                                ? "No"
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(2, 3, 2, 5)}>
                                        <b style={{ wordBreak: "break-all" }}>
                                            {report.q1_action_taken
                                                ? report.q1_action_taken
                                                : "N/A"}
                                        </b>
                                    </div>

                                    <div style={cstyle(3, 1, 3, 2)}>
                                        <b>
                                            2. &nbsp;Are you keeping up to date
                                            with the latest COVD-19 advice from
                                            Government?
                                        </b>
                                    </div>
                                    <div style={cstyle(3, 2, 3, 3)}>
                                        <b>
                                            {report.q2_value === "Yes"
                                                ? "Yes"
                                                : report.q2_value === "No"
                                                ? "No"
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(3, 3, 3, 5)}>
                                        <b style={{ wordBreak: "break-all" }}>
                                            {report.q2_action_taken
                                                ? report.q2_action_taken
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(4, 1, 4, 2)}>
                                        <b>
                                            3. &nbsp;Are you aware of the signs
                                            and symptoms of COVID-19?
                                        </b>
                                    </div>
                                    <div style={cstyle(4, 2, 4, 3)}>
                                        <b>
                                            {report.q3_value === "Yes"
                                                ? "Yes"
                                                : report.q3_value === "No"
                                                ? "No"
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(4, 3, 4, 5)}>
                                        <b style={{ wordBreak: "break-all" }}>
                                            {report.q3_action_taken
                                                ? report.q3_action_taken
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(5, 1, 5, 5)}>
                                        <a
                                            href="https://www2.hse.ie/conditions/coronavirus/symptoms.html"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            [Click for Signs and Symptoms of
                                            COVID-19]
                                        </a>
                                    </div>
                                    <div style={cstyle(6, 1, 6, 2)}>
                                        <b>
                                            4. &nbsp;Do you know how the virus
                                            is spread?
                                        </b>
                                    </div>
                                    <div style={cstyle(6, 2, 6, 3)}>
                                        <b>
                                            {report.q4_value === "Yes"
                                                ? "Yes"
                                                : report.q4_value === "No"
                                                ? "No"
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(6, 3, 6, 5)}>
                                        <b style={{ wordBreak: "break-all" }}>
                                            {report.q4_action_taken
                                                ? report.q4_action_taken
                                                : "N/A"}
                                        </b>
                                    </div>

                                    <div style={cstyle(7, 1, 7, 5)}>
                                        <a
                                            href="https://www2.hse.ie/conditions/coronavirus/how-coronavirus-is-spread.html"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            [Click for How The Virus is Spread]
                                        </a>
                                    </div>

                                    <div style={cstyle(8, 1, 8, 2)}>
                                        <b>
                                            5. &nbsp;Have you completed COVID-19
                                            return-to-work form and given it to
                                            your employer? <br />
                                            (See template Return-to-Work form)
                                        </b>
                                    </div>
                                    <div style={cstyle(8, 2, 8, 3)}>
                                        <b>
                                            {report.q5_value === "Yes"
                                                ? "Yes"
                                                : report.q5_value === "No"
                                                ? "No"
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(8, 3, 8, 5)}>
                                        <b style={{ wordBreak: "break-all" }}>
                                            {report.q5_action_taken
                                                ? report.q5_action_taken
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(9, 1, 9, 2)}>
                                        <b>
                                            6. &nbsp;Have you told your employer
                                            if you fall into any of the at-risk
                                            categories?
                                        </b>
                                    </div>
                                    <div style={cstyle(9, 2, 9, 3)}>
                                        <b>
                                            {report.q6_value === "Yes"
                                                ? "Yes"
                                                : report.q6_value === "No"
                                                ? "No"
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(9, 3, 9, 5)}>
                                        <b style={{ wordBreak: "break-all" }}>
                                            {report.q6_action_taken
                                                ? report.q6_action_taken
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(10, 1, 10, 5)}>
                                        <a
                                            href="https://www2.hse.ie/conditions/coronavirus/people-at-higher-risk.html"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            [Click for At-Risk Categories]
                                        </a>
                                    </div>
                                    <div style={cstyle(11, 1, 11, 2)}>
                                        <b>
                                            7. &nbsp;Have you been given an
                                            induction before returning to work
                                            and made aware <br />
                                            of the control measures your
                                            employer has put in place to
                                            minimise the risk of you <br />
                                            and others being exposed to
                                            COVID-19? (See Checklist No. 2
                                            Control Measures) ?
                                        </b>
                                    </div>
                                    <div style={cstyle(11, 2, 11, 3)}>
                                        <b>
                                            {report.q7_value === "Yes"
                                                ? "Yes"
                                                : report.q7_value === "No"
                                                ? "No"
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(11, 3, 11, 5)}>
                                        <b style={{ wordBreak: "break-all" }}>
                                            {report.q7_action_taken
                                                ? report.q7_action_taken
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(12, 1, 12, 2)}>
                                        <b>
                                            8. &nbsp;Did your employer consult
                                            with you when putting these control
                                            measures in place?
                                        </b>
                                    </div>
                                    <div style={cstyle(12, 2, 12, 3)}>
                                        <b>
                                            {report.q8_value === "Yes"
                                                ? "Yes"
                                                : report.q8_value === "No"
                                                ? "No"
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(12, 3, 12, 5)}>
                                        <b style={{ wordBreak: "break-all" }}>
                                            {report.q8_action_taken
                                                ? report.q8_action_taken
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(13, 1, 13, 2)}>
                                        <b>
                                            9. &nbsp;Have you co-operated with
                                            your employer to make sure these
                                            control measures are maintained?
                                        </b>
                                    </div>
                                    <div style={cstyle(13, 2, 13, 3)}>
                                        <b>
                                            {report.q9_value === "Yes"
                                                ? "Yes"
                                                : report.q9_value === "No"
                                                ? "No"
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(13, 3, 13, 5)}>
                                        <b style={{ wordBreak: "break-all" }}>
                                            {report.q9_action_taken
                                                ? report.q9_action_taken
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(14, 1, 14, 2)}>
                                        <b>
                                            10. &nbsp;Do you know who your
                                            Worker Representative is and how to
                                            contact him / her?
                                        </b>
                                    </div>
                                    <div style={cstyle(14, 2, 14, 3)}>
                                        <b>
                                            {report.q10_value === "Yes"
                                                ? "Yes"
                                                : report.q10_value === "No"
                                                ? "No"
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(14, 3, 14, 5)}>
                                        <b style={{ wordBreak: "break-all" }}>
                                            {report.q10_action_taken
                                                ? report.q10_action_taken
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(15, 1, 15, 2)}>
                                        <b>
                                            11. &nbsp;Do you know how to contact
                                            your Worker Representative if you
                                            have any <br />
                                            concerns about exposure to COVID-19,
                                            control measures not been maintained
                                            or have any
                                            <br />
                                            suggestions that could help prevent
                                            the spread of the virus?
                                        </b>
                                    </div>
                                    <div style={cstyle(15, 2, 15, 3)}>
                                        <b>
                                            {report.q11_value === "Yes"
                                                ? "Yes"
                                                : report.q11_value === "No"
                                                ? "No"
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(15, 3, 15, 5)}>
                                        <b style={{ wordBreak: "break-all" }}>
                                            {report.q11_action_taken
                                                ? report.q11_action_taken
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(16, 1, 16, 2)}>
                                        <b>
                                            12. &nbsp;Do you know what to do in
                                            relation to physical distancing,
                                            good hand hygiene
                                            <br />
                                            and respiratory etiquette?
                                        </b>
                                    </div>
                                    <div style={cstyle(16, 2, 16, 3)}>
                                        <b>
                                            {report.q12_value === "Yes"
                                                ? "Yes"
                                                : report.q12_value === "No"
                                                ? "No"
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(16, 3, 16, 5)}>
                                        <b style={{ wordBreak: "break-all" }}>
                                            {report.q12_action_taken
                                                ? report.q12_action_taken
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(17, 1, 17, 2)}>
                                        <b>
                                            13. &nbsp;Do you know how to wash
                                            your hands properly?
                                        </b>
                                    </div>
                                    <div style={cstyle(17, 2, 17, 3)}>
                                        <b>
                                            {report.q13_value === "Yes"
                                                ? "Yes"
                                                : report.q13_value === "No"
                                                ? "No"
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(17, 3, 17, 5)}>
                                        <b style={{ wordBreak: "break-all" }}>
                                            {report.q13_action_taken
                                                ? report.q13_action_taken
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(18, 1, 18, 2)}>
                                        <b>
                                            14. &nbsp;Do you know when to wash
                                            your hands: i.e.
                                            <br />
                                            &nbsp;•&nbsp;Before and after eating
                                            and preparing food
                                            <br />
                                            &nbsp;•&nbsp;After coughing or
                                            sneezing
                                            <br />
                                            &nbsp;•&nbsp;After using the toilet
                                            <br />
                                            &nbsp;•&nbsp;Before smoking or
                                            vaping
                                            <br />
                                            &nbsp;•&nbsp;Where hands are dirty
                                            <br />
                                            &nbsp;•&nbsp;Before and after
                                            wearing gloves
                                            <br />
                                            &nbsp;•&nbsp;Before and after being
                                            on public transport
                                            <br />
                                            &nbsp;•&nbsp;Before leaving home
                                            <br />
                                            &nbsp;•&nbsp;When arriving/leaving
                                            the workplace/other sites
                                            <br />
                                            &nbsp;•&nbsp;After changing tasks
                                            <br />
                                            &nbsp;•&nbsp;After touching
                                            potentially contaminated surfaces
                                            <br />
                                            &nbsp;•&nbsp;If in contact with
                                            someone displaying any COVID-19
                                            symptoms
                                        </b>
                                    </div>
                                    <div style={cstyle(18, 2, 18, 3)}>
                                        <b>
                                            {report.q14_value === "Yes"
                                                ? "Yes"
                                                : report.q14_value === "No"
                                                ? "No"
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(18, 3, 18, 5)}>
                                        <b style={{ wordBreak: "break-all" }}>
                                            {report.q14_action_taken
                                                ? report.q14_action_taken
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(19, 1, 19, 2)}>
                                        <b>
                                            15. &nbsp;Do you know where your
                                            nearest hand washing / hand
                                            sanitising stations are?
                                        </b>
                                    </div>
                                    <div style={cstyle(19, 2, 19, 3)}>
                                        <b>
                                            {report.q15_value === "Yes"
                                                ? "Yes"
                                                : report.q15_value === "No"
                                                ? "No"
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(19, 3, 19, 5)}>
                                        <b style={{ wordBreak: "break-all" }}>
                                            {report.q15_action_taken
                                                ? report.q15_action_taken
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(20, 1, 20, 2)}>
                                        <b>
                                            16. &nbsp;Do you know to avoid
                                            touching your face?
                                        </b>
                                    </div>
                                    <div style={cstyle(20, 2, 20, 3)}>
                                        <b>
                                            {report.q16_value === "Yes"
                                                ? "Yes"
                                                : report.q16_value === "No"
                                                ? "No"
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(20, 3, 20, 5)}>
                                        <b style={{ wordBreak: "break-all" }}>
                                            {report.q16_action_taken
                                                ? report.q16_action_taken
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(21, 1, 21, 2)}>
                                        <b>
                                            17. &nbsp;Do you know to keep 2
                                            metres physical distancing from
                                            others at all times at work,
                                            <br /> including in any canteen or
                                            wash/changing room?
                                        </b>
                                    </div>
                                    <div style={cstyle(21, 2, 21, 3)}>
                                        <b>
                                            {report.q17_value === "Yes"
                                                ? "Yes"
                                                : report.q17_value === "No"
                                                ? "No"
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(21, 3, 21, 5)}>
                                        <b style={{ wordBreak: "break-all" }}>
                                            {report.q17_action_taken
                                                ? report.q17_action_taken
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(22, 1, 22, 2)}>
                                        <b>
                                            18. &nbsp;Do you know to avoid any
                                            physical contact with colleagues,
                                            customers or visitors?
                                        </b>
                                    </div>
                                    <div style={cstyle(22, 2, 22, 3)}>
                                        <b>
                                            {report.q18_value === "Yes"
                                                ? "Yes"
                                                : report.q18_value === "No"
                                                ? "No"
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(22, 3, 22, 5)}>
                                        <b style={{ wordBreak: "break-all" }}>
                                            {report.q18_action_taken
                                                ? report.q18_action_taken
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(23, 1, 23, 2)}>
                                        <b>
                                            19. &nbsp;Do you know what to do if
                                            you start to develop symptoms of
                                            COVID-19 while at work, <br />
                                            including where the isolation area
                                            is? (See Checklist No. 4)
                                        </b>
                                    </div>
                                    <div style={cstyle(23, 2, 23, 3)}>
                                        <b>
                                            {report.q19_value === "Yes"
                                                ? "Yes"
                                                : report.q19_value === "No"
                                                ? "No"
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(23, 3, 23, 5)}>
                                        <b style={{ wordBreak: "break-all" }}>
                                            {report.q19_action_taken
                                                ? report.q19_action_taken
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(24, 1, 24, 2)}>
                                        <b>
                                            20. &nbsp;Do you understand the
                                            purpose of giving your employer any
                                            necessary information
                                            <br />
                                            to maintain a COVID-19 contact log?
                                        </b>
                                    </div>
                                    <div style={cstyle(24, 2, 24, 3)}>
                                        <b>
                                            {report.q20_value === "Yes"
                                                ? "Yes"
                                                : report.q20_value === "No"
                                                ? "No"
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(24, 3, 24, 5)}>
                                        <b style={{ wordBreak: "break-all" }}>
                                            {report.q20_action_taken
                                                ? report.q20_action_taken
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(25, 1, 25, 2)}>
                                        <b>
                                            21. &nbsp;Do you understand any
                                            proposed new staff rosters, changing
                                            of start / finish times,
                                            <br />
                                            rostering of breaks etc?
                                        </b>
                                    </div>
                                    <div style={cstyle(25, 2, 25, 3)}>
                                        <b>
                                            {report.q21_value === "Yes"
                                                ? "Yes"
                                                : report.q21_value === "No"
                                                ? "No"
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(25, 3, 25, 5)}>
                                        <b style={{ wordBreak: "break-all" }}>
                                            {report.q21_action_taken
                                                ? report.q21_action_taken
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(26, 1, 26, 2)}>
                                        <b>
                                            22. &nbsp;Have you been made aware
                                            of any changes to risk assessments
                                            relevant to your work activities
                                            <br />
                                            and any changes in the safety
                                            statement in response to controls to
                                            minimise the risk of you <br />
                                            and others being exposed to
                                            COVID-19?
                                        </b>
                                    </div>
                                    <div style={cstyle(26, 2, 26, 3)}>
                                        <b>
                                            {report.q22_value === "Yes"
                                                ? "Yes"
                                                : report.q22_value === "No"
                                                ? "No"
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(26, 3, 26, 5)}>
                                        <b style={{ wordBreak: "break-all" }}>
                                            {report.q22_action_taken
                                                ? report.q22_action_taken
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(27, 1, 27, 2)}>
                                        <b>
                                            23. &nbsp;Have you been made aware
                                            of any changes to the emergency
                                            plans or first aid procedures for
                                            your <br />
                                            workplace in response to controls to
                                            minimise the risk of you and others
                                            being exposed to COVID-19?
                                        </b>
                                    </div>
                                    <div style={cstyle(27, 2, 27, 3)}>
                                        <b>
                                            {report.q23_value === "Yes"
                                                ? "Yes"
                                                : report.q23_value === "No"
                                                ? "No"
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(27, 3, 27, 5)}>
                                        <b style={{ wordBreak: "break-all" }}>
                                            {report.q23_action_taken
                                                ? report.q23_action_taken
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(28, 1, 28, 2)}>
                                        <b>
                                            24. &nbsp;Do you know to avoid
                                            sharing items such as cups, bottles,
                                            cutlery, pens etc.?
                                        </b>
                                    </div>
                                    <div style={cstyle(28, 2, 28, 3)}>
                                        <b>
                                            {report.q24_value === "Yes"
                                                ? "Yes"
                                                : report.q24_value === "No"
                                                ? "No"
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(28, 3, 28, 5)}>
                                        <b style={{ wordBreak: "break-all" }}>
                                            {report.q24_action_taken
                                                ? report.q24_action_taken
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(29, 1, 29, 2)}>
                                        <b>
                                            25. &nbsp;Have you been made aware
                                            that any personal items brought into
                                            work must be cleaned and to avoid{" "}
                                            <br />
                                            leaving them down on communal
                                            surfaces or to clean the surface
                                            after the personal item is removed?
                                        </b>
                                    </div>
                                    <div style={cstyle(29, 2, 29, 3)}>
                                        <b>
                                            {report.q25_value === "Yes"
                                                ? "Yes"
                                                : report.q25_value === "No"
                                                ? "No"
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(29, 3, 29, 5)}>
                                        <b style={{ wordBreak: "break-all" }}>
                                            {report.q25_action_taken
                                                ? report.q25_action_taken
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(30, 1, 30, 2)}>
                                        <b>
                                            26. &nbsp;Have you been provided
                                            with cleaning materials, including
                                            gloves <br />
                                            and disinfectant to clean your own
                                            workspace twice daily?
                                        </b>
                                    </div>
                                    <div style={cstyle(30, 2, 30, 3)}>
                                        <b>
                                            {report.q26_value === "Yes"
                                                ? "Yes"
                                                : report.q26_value === "No"
                                                ? "No"
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(30, 3, 30, 5)}>
                                        <b style={{ wordBreak: "break-all" }}>
                                            {report.q26_action_taken
                                                ? report.q26_action_taken
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(31, 1, 31, 2)}>
                                        <b>
                                            27. &nbsp;Do you know to clean your
                                            hands before and after using public{" "}
                                            <br />
                                            transport when commuting and when
                                            you enter and exit the workplace?
                                        </b>
                                    </div>
                                    <div style={cstyle(31, 2, 31, 3)}>
                                        <b>
                                            {report.q27_value === "Yes"
                                                ? "Yes"
                                                : report.q27_value === "No"
                                                ? "No"
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(31, 3, 31, 5)}>
                                        <b style={{ wordBreak: "break-all" }}>
                                            {report.q27_action_taken
                                                ? report.q27_action_taken
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(32, 1, 32, 2)}>
                                        <b>
                                            28. &nbsp;Can you avoid work-related
                                            travel as far as possible and are
                                            you able to conduct meetings with{" "}
                                            <br />
                                            colleagues / clients / customers in
                                            other forms e.g. phone, online
                                            rather than in person?
                                        </b>
                                    </div>
                                    <div style={cstyle(32, 2, 32, 3)}>
                                        <b>
                                            {report.q28_value === "Yes"
                                                ? "Yes"
                                                : report.q28_value === "No"
                                                ? "No"
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(32, 3, 32, 5)}>
                                        <b style={{ wordBreak: "break-all" }}>
                                            {report.q28_action_taken
                                                ? report.q28_action_taken
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(33, 1, 33, 2)}>
                                        <b>
                                            29. &nbsp;If using your own car for
                                            work, will you travel alone?
                                        </b>
                                    </div>
                                    <div style={cstyle(33, 2, 33, 3)}>
                                        <b>
                                            {report.q29_value === "Yes"
                                                ? "Yes"
                                                : report.q29_value === "No"
                                                ? "No"
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(33, 3, 33, 5)}>
                                        <b style={{ wordBreak: "break-all" }}>
                                            {report.q29_action_taken
                                                ? report.q29_action_taken
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(34, 1, 34, 2)}>
                                        <b>
                                            30. &nbsp;If you have to share a
                                            work vehicle, have you access to a
                                            face covering and products <br />
                                            such as wipes to clean the vehicle’s
                                            frequently touched surfaces at the
                                            start and end of each shift?
                                        </b>
                                    </div>
                                    <div style={cstyle(34, 2, 34, 3)}>
                                        <b>
                                            {report.q30_value === "Yes"
                                                ? "Yes"
                                                : report.q30_value === "No"
                                                ? "No"
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(34, 3, 34, 5)}>
                                        <b style={{ wordBreak: "break-all" }}>
                                            {report.q30_action_taken
                                                ? report.q30_action_taken
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(35, 1, 35, 2)}>
                                        <b>
                                            31. &nbsp;Do you know when you have
                                            to wear PPE and how to fit, use,
                                            remove, clean, store
                                            <br />
                                            and dispose of any required PPE?
                                        </b>
                                    </div>
                                    <div style={cstyle(35, 2, 35, 3)}>
                                        <b>
                                            {report.q31_value === "Yes"
                                                ? "Yes"
                                                : report.q31_value === "No"
                                                ? "No"
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(35, 3, 35, 5)}>
                                        <b style={{ wordBreak: "break-all" }}>
                                            {report.q31_action_taken
                                                ? report.q31_action_taken
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(36, 1, 36, 2)}>
                                        <b>
                                            32. &nbsp;Do you know what supports
                                            are available to you if you are
                                            feeling anxious or stressed?
                                        </b>
                                    </div>
                                    <div style={cstyle(36, 2, 36, 3)}>
                                        <b>
                                            {report.q32_value === "Yes"
                                                ? "Yes"
                                                : report.q32_value === "No"
                                                ? "No"
                                                : "N/A"}
                                        </b>
                                    </div>
                                    <div style={cstyle(36, 3, 36, 5)}>
                                        <b style={{ wordBreak: "break-all" }}>
                                            {report.q32_action_taken
                                                ? report.q32_action_taken
                                                : "N/A"}
                                        </b>
                                    </div>
                                </div>
                            </div>

                            <div style={{ width: "100%", clear: "both" }}>
                                <div style={gstyle(4, 9, null)}>
                                    <div
                                        style={cstyle(1, 1, 1, 1, false, true)}
                                    >
                                        <b>Attached Signatures</b>
                                    </div>
                                    {report.attached_signatures &&
                                        this.renderSigs(
                                            report.attached_signatures
                                        )}
                                </div>
                                <br />
                                <br />
                                <div style={gstyle(4, 9, null)}>
                                    <div
                                        style={cstyle(1, 1, 1, 1, false, true)}
                                    >
                                        <b>Thumbs Up</b>
                                    </div>
                                    {report.attached_thumbsup_photos &&
                                        this.renderPhotos(
                                            report.attached_thumbsup_photos
                                        )}
                                </div>
                            </div>
                            <div
                                style={{
                                    width: "100%",
                                    clear: "both",
                                    marginBottom: "10px",
                                    marginTop: "10px",
                                }}
                            >
                                <Typography
                                    style={{
                                        border: "4px solid #0188cc",
                                        borderRadius: "6px",
                                        padding: "5px",
                                    }}
                                >
                                    <b>
                                        The information contained in this
                                        guidance is for educational purposes
                                        only and is non-exhaustive. It is not
                                        intended to provide legal advice to you,
                                        and you should not rely upon the
                                        information to provide any such advice.
                                        We do not provide any warranty, express
                                        or implied, of its accuracy or
                                        completeness. The Health and Safety
                                        Authority shall not be liable in any
                                        manner or to any extent for any direct,
                                        indirect, special, incidental or
                                        consequential damages, losses or
                                        expenses arising out of the use of this
                                        checklist.{" "}
                                    </b>
                                </Typography>
                            </div>
                        </div>
                    )}
                    {report && (
                        <Modal isOpen={this.state.imageModal}>
                            <ModalHeader>Details</ModalHeader>
                            <ModalBody style={{ margin: "auto" }}>
                                <img
                                    src={
                                        this.state.selectedImg
                                            ? this.state.selectedImg
                                            : noImg
                                    }
                                    alt="Site"
                                    style={{ width: "350px", height: "350px" }}
                                />
                            </ModalBody>
                            <ModalFooter>
                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        this.setState({
                                            selectedImg: "",
                                            imageModal: false,
                                        });
                                    }}
                                >
                                    Close
                                </Button>
                            </ModalFooter>
                        </Modal>
                    )}
                </CardContent>
            </Card>
        );
    }
}

export default connect(
    (store) => {
        return {
            report: selectCurrentReport(store),
        };
    },
    { getReport, getStandaloneReport }
)(CovidReturnToWork);
